module.exports = __webpack_public_path__ + "static/panescreenshot-ebd5731b3a124efe432d2ce8fb9cabdb.png";